import { InventoryLocationBuildingFloorplansApiClient } from '../services/api/inventoryLocationBuildingFloorplans';

let inventoryLocationBuildingFloorplan: InventoryLocationBuildingFloorplansApiClient;

const inventoryLocationBuildingFloorplanFactory = () =>
  (inventoryLocationBuildingFloorplan = new InventoryLocationBuildingFloorplansApiClient());

/**
 * @deprecated Use `useServices` hook instead.
 */
export const getInventoryLocationBuildingFloorplanApi = (): InventoryLocationBuildingFloorplansApiClient =>
  inventoryLocationBuildingFloorplan ?? inventoryLocationBuildingFloorplanFactory();
